var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.40757 2.66667C7.40757 3.03486 7.70906 3.33333 8.08098 3.33333C8.4529 3.33333 8.75439 3.03486 8.75439 2.66667C8.75439 2.29848 8.4529 2 8.08098 2C7.70906 2 7.40757 2.29848 7.40757 2.66667Z",
    stroke: "#00529C",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40757 8.00065C7.40757 8.36884 7.70906 8.66732 8.08098 8.66732C8.4529 8.66732 8.75439 8.36884 8.75439 8.00065C8.75439 7.63246 8.4529 7.33398 8.08098 7.33398C7.70906 7.33398 7.40757 7.63246 7.40757 8.00065Z",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40757 13.3327C7.40757 13.7009 7.70906 13.9993 8.08098 13.9993C8.4529 13.9993 8.75439 13.7009 8.75439 13.3327C8.75439 12.9645 8.4529 12.666 8.08098 12.666C7.70906 12.666 7.40757 12.9645 7.40757 13.3327Z",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreBlack);
export default __webpack_public_path__ + "static/media/more-black.503a6c0056f17549b9f1ef16a81508cc.svg";
export { ForwardRef as ReactComponent };